<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_q1}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
        <div class="form-group row">
            <label class="col-sm-4 col-form-label font18" style="padding-left: 60px;">Tenure</label>
            <div class="col-sm-8 mt-1">
                <!-- <select [(ngModel)]="tenure" (change)="getTenure($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let tenure of tenure_months" value={{tenure}}>{{tenure}}</option>
                </select> -->
                <ng-select [items]="tenure_months" placeholder="Select" [searchable]="false" [clearable]="false"
          (change)="getTenure(tenure);" [(ngModel)]="tenure">
        </ng-select>
            </div>
        </div>
    </div>
    <button  *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
        <div class="d-flex h-100 row col-sm-12 pr-0">
                <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
                <img style="width:100%;" src="assets/images/signimg.jpg" />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box" >
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="col-sm-12 m-auto">
        <div class="col-12 form-group px-0 mt-2 d-flex flex-wrap" style="margin-bottom:4px !important">
            
            <label class="col-5 col-form-label text-right">Tenure</label>
            <div class="col-7 px-0 mt-1">
                <!-- <select [(ngModel)]="tenure" (change)="getTenure($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let tenure of tenure_months" value={{tenure}}>{{tenure}}</option>
                </select> -->
                <ng-select [items]="tenure_months" placeholder="Select" [searchable]="true" [clearable]="false"
                    (change)="getTenure(tenure);" [(ngModel)]="tenure"></ng-select>
            </div>
        </div>
        <div style="width:97% !important; text-align: right;">
        <div *ngIf="user_bot"  class="ash_box text-right mt-2 mb-2" >
            <h1  class="ansMob text-right">{{tenure}}</h1>
        </div>
        </div>
    </div>
</div>
